import * as messages from 'common/constants/messages/validations';
import { emailValidatorBase } from 'common/constants/userSchemaBase';

export const CONSTRAINTS_PASSWORD_RESET = {
  mail: {
    presence: {
      allowEmpty: false,
      message: messages.IS_REQUIRED,
    },
    length: {
      maximum: 128,
      minimum: 5,
      message: messages.REQUIRE_CHARACTERS(5),
    },
    ...emailValidatorBase,
  },
};

export const CONSTRAINTS_PASSWORD_CHANGE = {
  password: {
    presence: {
      allowEmpty: false,
      message: messages.IS_REQUIRED,
    },
  },
  passwordConfirmation: {
    presence: {
      allowEmpty: false,
      message: messages.IS_REQUIRED,
    },
  },
};

export const DEFAULT_ERROR_MESSAGE = messages.FIX_BEFORE_CONTINUE;

export const REGEXP_LIST = [
  /^\S{9,}$/, // 9 characters or more (Not whitespace)
  /[a-z]+/i, // At least 1 letter
  /\d+/, // At least 1 digit
  /\W+/, // At least 1 special character
];

export const PASSWORD_CHECKS = [
  '9 characters',
  '1 letter',
  '1 number',
  '1 special character',
  'Passwords must match',
];
